import React from 'react'
import FacetMultiSelect from '../BaseComponents/FacetMultiSelect'

const TagFacet = () => (
  <FacetMultiSelect facetCategory="tag" source="tagFacets" />
)

export default TagFacet
